<template>
  <div class="content-useful-files-cards-sections">
    <div class="cards-useful-files-cards-sections">
      <div
        v-for="card in orderedCards"
        :key="card.id"
        class="item-useful-files-cards-sections"
      >
        <CardUsefulFiles
          :backgroundImageUrl="getCardMedia(card)"
          :cardText="getCardText(card)"
          :navigationUrl="getCardLink(card)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { PageStoreContract } from '@/data/store/page.store.contract'
import { getModule } from 'vuex-module-decorators'
import CardUsefulFiles from '../CardUsefulFiles.vue'
import UsefulFilesPageMixin from '@/mixins/useful-files-page-mixin'
import { UsefulFilesPageStore } from '@/store/useful-files-page/useful-files-store'

type CardReference = {
  id: string
  containerIndex: number
  elementIndex: number
}

@Component({
  components: {
    CardUsefulFiles
  }
})
export default class UsefulFilesCardsSections extends Mixins(UsefulFilesPageMixin) {
  usefulFilesPageStore: PageStoreContract = getModule(UsefulFilesPageStore, this.$store)

  get orderedCards(): CardReference[] {
    return [
      { id: 'others-2', containerIndex: 3, elementIndex: 2 },
      { id: 'backgrounds-2', containerIndex: 1, elementIndex: 2 },
      { id: 'backgrounds-0', containerIndex: 1, elementIndex: 0 },
      { id: 'backgrounds-1', containerIndex: 1, elementIndex: 1 },
      { id: 'brand-0', containerIndex: 2, elementIndex: 0 },
      { id: 'brand-1', containerIndex: 2, elementIndex: 1 },
      { id: 'brand-2', containerIndex: 3, elementIndex: 3 },
      { id: 'others-0', containerIndex: 3, elementIndex: 0 },
      { id: 'others-1', containerIndex: 3, elementIndex: 1 }
    ]
  }

  getCardMedia(card: CardReference): string {
    return this.getElementMedia(card.containerIndex, card.elementIndex)
  }

  getCardText(card: CardReference): string {
    return this.getElementText(card.containerIndex, card.elementIndex)
  }

  getCardLink(card: CardReference): string | null {
    return this.getElementLink(card.containerIndex, card.elementIndex)
  }

  async getUsefulFilesPage(): Promise<void> {
    await this.usefulFilesPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.usefulFilesPageStore.isLoading) {
      await this.getUsefulFilesPage()
    }
  }
}
</script>

<style scoped lang="scss">
.content-useful-files-cards-sections {
  padding-top: 1rem;
  max-width: 1032px;
  width: 100%;
}

.cards-useful-files-cards-sections {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  max-width: 1032px;
  padding-bottom: 6rem;
}

@media (min-width: 1726px) {
  .content-useful-files-cards-sections {
    margin-top: 0rem;
  }
}
</style>
